// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passwordGenerationContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;

}


.error_popup {
    position: absolute;
}

.error_popup span {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    font-size: 12px;
    padding: 3px;
    color: red;
}

.password_link_expiry_popup {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.password_link_expiry_popup .card .card-body {
    padding: 50px;
}

.password_link_expiry_popup p:hover {
    color: var(--admin-color);
}

.password_link_expiry_popup button {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}


.password_not_matched {
    border: 1px solid red !important;
    transition: 3s;
}

.password_matched{
    border: 1px solid green !important;
}

.normal{
    border: 1px solid #f3f3f3 !important;
}

.button_and_loader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    margin-top: 10px;
}

.hide_confirm_password_and_button {
    opacity: 0;
}


.button_and_loader .login_loader{
    height: 60px;
    position: absolute;
    top: -10px;
    left: 15%;
}

.Password_message{
    display: flex;
    justify-content: space-between;
}

.password-and-confirmPassword-toggle{
    position: absolute;
    right: 10px;
    top: 70%;
    transform: translateY(-50%);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Password Generation/PasswordGeneration.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;;AAEjB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;AACnB","sourcesContent":[".passwordGenerationContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n\n}\n\n\n.error_popup {\n    position: absolute;\n}\n\n.error_popup span {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: start;\n    font-size: 12px;\n    padding: 3px;\n    color: red;\n}\n\n.password_link_expiry_popup {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.password_link_expiry_popup .card .card-body {\n    padding: 50px;\n}\n\n.password_link_expiry_popup p:hover {\n    color: var(--admin-color);\n}\n\n.password_link_expiry_popup button {\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.password_not_matched {\n    border: 1px solid red !important;\n    transition: 3s;\n}\n\n.password_matched{\n    border: 1px solid green !important;\n}\n\n.normal{\n    border: 1px solid #f3f3f3 !important;\n}\n\n.button_and_loader {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    position: relative;\n    margin-top: 10px;\n}\n\n.hide_confirm_password_and_button {\n    opacity: 0;\n}\n\n\n.button_and_loader .login_loader{\n    height: 60px;\n    position: absolute;\n    top: -10px;\n    left: 15%;\n}\n\n.Password_message{\n    display: flex;\n    justify-content: space-between;\n}\n\n.password-and-confirmPassword-toggle{\n    position: absolute;\n    right: 10px;\n    top: 70%;\n    transform: translateY(-50%);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
